export const MENU_SET_FILTER = 'MENU_SET_FILTER';
export const APP_ERROR='APP_ERROR'

export const APP_CLEAR='APP_CLEAR'

//export const USER_SET_LOGIN_DATA = 'USER_SET_LOGIN_DATA';
//export const USER_SET_MBAUTH_DATA = 'USER_SET_MBAUTH_DATA';
export const USER_LOGIN='USER_LOGIN'
export const USER_LOGOUT='USER_LOGOUT'
export const USER_SET_AGENT='USER_SET_AGENT'

export const TOWNS_SET_ALL='TOWNS_SET_ALL'
export const TOWNS_SET_TO='TOWNS_SET_TO'

export const COURSES_SEARCHING='COURSES_SEARCHING'
export const COURSES_SET_LIST='COURSES_SET_LIST'
export const COURSES_CHOOSE='COURSES_CHOOSE'
export const COURSES_CANCELCHOOSE='COURSES_CANCELCHOOSE'

export const REPORT_RES_SET_LIST='REPORT_RES_SET_LIST'
export const REPORT_RES_CLEAR_LIST='REPORT_RES_CLEAR_LIST'
export const REPORT_RES_SET_INFO='REPORT_RES_SET_INFO'

export const REPORT_REFUNDS_SET_LIST='REPORT_REFUNDS_SET_LIST'
export const REPORT_REFUNDS_CLEAR_LIST='REPORT_REFUNDS_CLEAR_LIST'
export const REPORT_REFUNDS_SET_INFO='REPORT_REFUNDS_SET_INFO'

export const REPORT_SALES_SET_LIST='REPORT_SALES_SET_LIST'
export const REPORT_SALES_CLEAR_LIST='REPORT_SALES_CLEAR_LIST'
export const REPORT_SALES_SET_INFO='REPORT_SALES_SET_INFO'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js